import {
  makeAutoObservable,
  observable,
  action,
  computed,
  runInAction,
  toJS,
  autorun,
  onBecomeUnobserved,
  reaction,
} from "mobx";
import { commonAxios } from "../../pages/ExperianPage/CommonAxios";
import { showAlertToast } from "../../Components/ToastComponent/AlertMessage";
const initialStore = {
  euro: "1",
  creditperEuro: "0",
}
class CreditConfigurationStore {
  tableData = [];
  commonRootStoreMap;
  constructor(rootstore) {
    this.rootstore = rootstore;
    this.commonRootStoreMap = new Map(Object.entries(initialStore));
    makeAutoObservable(this);
  }
  applyTheValue(updates) {
    runInAction(() => {
      for (const [key, value] of Object.entries(updates)) {
        this.commonRootStoreMap.set(key, value);
      }
    });
  }
  getThevalue(key) {
    return this.commonRootStoreMap.get(key);
  }
  getCreditCount = async () => {
    try {
      const response = await commonAxios(
        "/getSettings",
        "GET",
        {
          type: 'addCredit'
        }
      );
      runInAction(() => {
        this.applyTheValue({ creditperEuro: response?.data?.creditsCount, euro: response?.data?.pricing })
      })
    }
    catch (error) {
    }
  }
  handleCreditsChange = (obj, value) => {
    runInAction(() => {
      this.tableData = this.tableData.map((element) =>
        element._id === obj._id ? { ...element, price: value } : element
      );
    });
    const updatedObj = this.tableData.find(
      (element) => element._id === obj._id
    );
    if (updatedObj) {
      this.handleUpdateCreditConfig(updatedObj, "updatePrice");
    }
  };
  handleSubmitCredit = async () => {
    try {
      const response = await commonAxios(
        "/updateSettings",
        "post",
        {},
        {
          type: 'addCredit',
          pricing: this.getThevalue("euro"),
          creditsCount: this.getThevalue("creditperEuro")
        }
      );
      console.log(response, "Got in data for response");
      if (response?.statusCode === 200) {
        showAlertToast({
          type: "success",
          title: "Successfully Updatted",
          message: response?.data?.message ?? "Successfully updated Credit per Euro value.",
        });
      }
    }
    catch (error) {
      showAlertToast({
        type: "error",
        title: "Error in Updatting",
        message: error?.message,
      });
    }
  }
  handleStatusUpdate = (obj, value) => {
    runInAction(() => {
      this.tableData = this.tableData.map((element) =>
        element._id === obj._id
          ? { ...element, status: value ? "active" : "inactive" }
          : element
      );
    });
    const updatedObj = this.tableData.find(
      (element) => element._id === obj._id
    );
    if (updatedObj) {
      this.handleUpdateCreditConfig(updatedObj, "updateStatus");
    }
  };
  handleCreditConfigurationTableData = async () => {
    try {
      const response = await commonAxios(
        "/getCreditConfigList",
        "POST",
        {},
        {}
      );
      if (response?.data) {
        runInAction(() => {
          this.tableData = response.data;
        });
      }
    } catch (e) {
    }
  };
  handleUpdateCreditConfig = async (obj, type) => {
    try {
      const response = await commonAxios(
        "/updateCreditConfig",
        "POST",
        {},
        {
          id: obj?._id,
          action: type,
          price: parseFloat(obj?.price),
          status: obj?.status,
        }
      );
    } catch (e) {
    }
  };
}
export default CreditConfigurationStore;
